/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style4 = require('antd/lib/modal/style');

var _modal = require('antd/lib/modal');

var _modal2 = _interopRequireDefault(_modal);

var _style5 = require('antd/lib/button/style');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style6 = require('antd/lib/form/style');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _immutable = require('immutable');

var _actions = require('../../../redux/actions');

var Actions = _interopRequireWildcard(_actions);

var _tool = require('../../../utils/tool');

var _config = require('../../../utils/config');

var _template = require('../../../common/template');

var _template2 = _interopRequireDefault(_template);

require('./index.less');

var _deviceForm = require('./device-form');

var _deviceForm2 = _interopRequireDefault(_deviceForm);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;

var _ref = (0, _jsx3.default)('span', {
  className: 'pile-name-desc'
}, void 0, '\u63A5\u5165\u8BBE\u5907\uFF0C\u8BF7\u586B\u5199\u6CE8\u518C\u7801');

var _ref2 = (0, _jsx3.default)('p', {
  className: 'more-regs-info'
}, void 0, (0, _jsx3.default)('a', {}, void 0, '\u6279\u91CF\u6CE8\u518C\u8BF4\u660E'));

var _ref3 = (0, _jsx3.default)('p', {}, void 0, '\u6B63\u5F0F\u73AF\u5883\u6CE8\u518C\u7801');

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    // this.state = 0;
    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this.showModal = function () {
      // this.setState({
      //   visible: true,
      // });
      var _this$props = _this.props,
          params = _this$props.params,
          product = _this$props.product;

      if (_this.state.productTemplate === 2) {
        _this.setState({
          visible: true
        });
      } else {
        _this.props.router.push({
          pathname: '/device/insert/' + params.id
        });
      }
    };

    _this.handleOk = function (e) {
      _this.setState({
        visible: false
      });
    };

    _this.handleCancel = function (e) {
      _this.setState({
        visible: false
      });
    };

    _this.addDevice = function (data, func) {
      var _this$props2 = _this.props,
          device = _this$props2.device,
          addDevice = _this$props2.addDevice;

      var deviceData = device.product ? device.product : {};
      var params = data[0];
      addDevice(params, function () {
        _this.handleAddCancel();
        func && func();
      });
    };

    _this.state = {
      visible: false,
      productTemplate: null
    };
    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: 'getProductTemplate',
    value: function getProductTemplate() {
      var _this2 = this;

      var params = this.props.params;

      (0, _tool.http)(_config.apiJson.getProductDetail, { productId: params.id }).then(function (res) {
        _this2.setState({
          productTemplate: res.productTemplate
        });
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getProductTemplate();
    }
  }, {
    key: 'copyText',
    value: function copyText(text) {
      _tool.copy.handle(text);
    }
  }, {
    key: 'render',
    value: function render() {

      // console.log(this.props)
      var _props = this.props,
          params = _props.params,
          device = _props.device,
          product = _props.product;
      var productTemplate = this.state.productTemplate;

      var data = device.product;
      data = data ? data : {};

      return (0, _jsx3.default)('div', {
        className: 'device-home',
        id: 'device-home'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'info'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'title'
      }, void 0, (0, _jsx3.default)('strong', {
        className: 'pile-name'
      }, void 0, data.name), _ref), (0, _jsx3.default)('div', {
        className: 'pile-regs-info'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'regs'
      }, void 0, _ref2, _ref3, (0, _jsx3.default)('p', {}, void 0, (0, _jsx3.default)('strong', {}, void 0, data.registerNumber), (0, _jsx3.default)('a', {
        href: 'javascript:void(0);',
        onClick: this.copyText.bind(this, data.registerNumber),
        className: 'copy'
      }, void 0, '\u590D\u5236\u6CE8\u518C\u7801'))))), (0, _jsx3.default)('div', {
        className: 'device-add-btn'
      }, void 0, (0, _jsx3.default)(_button2.default, {
        type: 'primary',
        className: 'add',
        onClick: this.showModal
      }, void 0, productTemplate === 2 ? '+新增设备' : '+新增车辆')), (0, _jsx3.default)(_modal2.default, {
        width: 720,
        className: 'cus-modal',
        title: '\u6CE8\u518C\u8BBE\u5907',
        visible: this.state.visible,
        onOk: this.handleOk,
        onCancel: this.handleCancel,
        footer: null
      }, void 0, _react2.default.createElement(_deviceForm2.default, {
        onCancel: this.handleCancel,
        onOk: this.handleOk,
        ref: 'subforms',
        addDevice: this.addDevice
      })));
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _template2.default)({
  id: 'device-home', //应用关联使用的redux
  component: Main, //接收数据的组件入口
  url: ''
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/device/home/index.jsx
// module id = 803
// module chunks = 0